import React, { useEffect, useState } from 'react';
import { X, AlertTriangle, Mail } from 'lucide-react';
import { EMAIL_DEMO_EVENT } from '../../hooks/useEmailGuard';

const EmailDemoModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(EMAIL_DEMO_EVENT, handler);
    return () => window.removeEventListener(EMAIL_DEMO_EVENT, handler);
  }, []);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[10001] flex items-center justify-center bg-black/50 p-4"
      onClick={() => setOpen(false)}
      data-testid="email-demo-modal"
    >
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative bg-gradient-to-r from-slate-900 to-indigo-800 px-6 py-5">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-xl bg-amber-400/20 flex items-center justify-center">
              <AlertTriangle size={20} className="text-amber-300" />
            </span>
            <h3 className="text-lg font-bold text-white">
              L'envoi d'e-mails est désactivé en version démo
            </h3>
          </div>
          <button
            onClick={() => setOpen(false)}
            className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors"
            data-testid="email-demo-modal-close"
            aria-label="Fermer"
          >
            <X size={20} />
          </button>
        </div>

        <div className="px-6 py-5 space-y-4 text-sm text-slate-700 leading-relaxed">
          <div className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
            <AlertTriangle size={18} className="text-amber-600 mt-0.5 flex-shrink-0" />
            <p className="font-semibold text-amber-800">
              ATTENTION : vous êtes en version démo — l'envoi d'e-mails est désactivé.
            </p>
          </div>
          <p className="flex items-start gap-2">
            <Mail size={18} className="text-indigo-500 mt-0.5 flex-shrink-0" />
            <span>
              La <strong>messagerie intégrée</strong> vous permet d'envoyer et de recevoir
              vos e-mails directement depuis vos boîtes partagées, avec pièces jointes,
              modèles et suivi client. Cette fonctionnalité est pleinement active dans la
              version complète de Pitboard.
            </span>
          </p>
        </div>

        <div className="px-6 pb-6">
          <button
            onClick={() => setOpen(false)}
            className="w-full px-4 py-2.5 bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-colors font-semibold text-sm"
            data-testid="email-demo-modal-ok"
          >
            J'ai compris
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailDemoModal;
